<template>
    <div>
        <!-- Modal Solicitação Estoque -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Solicitação de Materiais
                            <span v-if="item">
                                {{ item.id_estoque_solicitacao ? '#' + item.id_estoque_solicitacao : '(Nova)' }}
                                <span class="badge badge-primary ml-2" v-if="item.fl_estorno">
                                    <i class="fas fa-undo-alt mr-2"></i>
                                    Devolução
                                    <span v-if="item.fl_paciente">
                                        Paciente 
                                    </span>
                                </span>
                                <span class="badge badge-secondary ml-2" v-else-if="item.fl_transfer">
                                    <i class="fas fa-exchange-alt mr-2"></i>
                                    Transferência
                                </span>
                                <span class="badge badge-info ml-2" v-else-if="item.fl_solic_compra">
                                    <i class="fa-solid fa-dollar-sign mr-2"></i>
                                    Compra
                                </span>
                                <span class="badge badge-success ml-2" v-else>
                                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                    Consumo
                                    <span v-if="item.fl_paciente">
                                        Paciente 
                                    </span>
                                </span>
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="item">
                            <div class="">
                                <div class="spinner-border" role="status" v-if="!historico">
                                <span class="sr-only">Loading...</span>
                                </div>

                                <div v-else-if="!historico.length" class="alert alert-info mb-3">
                                    Nenhuma solicitação realizada.
                                </div>

                                <template v-else>

                                    <div class="card mt-2">
                                        <div class="card-header p-2 alert-info d-flex justify-content-between">
                                            <a class="card-link" data-toggle="collapse" href="#solic_anteriores">
                                                Solicitações Anteriores
                                            </a>
                                            <div>
                                                <span class="badge badge-secondary">
                                                    {{ historico.length }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="collapse" id="solic_anteriores">
                                            <table class="table table-sm mb-0 small" >
                                                <tbody>
                                                    <tr v-for="(solic, isx) in historico" :key="isx">
                                                        <td class="text-nowrap">
                                                            <a href="#" @click.prevent="editar(solic)">
                                                                #{{ solic.id_estoque_solicitacao }}
                                                            </a>

                                                            <a href="#" @click.prevent="copiar(solic)" title="Copiar Solicitação">
                                                                <i class="fas fa-copy ml-3"></i>
                                                            </a>
                                                        </td>
                                                        <td class="text-nowrap">
                                                            {{ $util.getFormatDate(solic.dt_solicitacao) }}
                                                            {{ solic.dt_solicitacao.substr(11,5) }}
                                                        </td>
                                                        <td>
                                                            {{ solic.local.search }}
                                                            <span v-if="solic.fl_transfer && solic.destino">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ solic.destino.search }}
                                                            </span>
                                                            <div v-else-if="solic.fl_paciente && solic.marcacao">
                                                                <i class="fa fa-user mr-2" aria-hidden="true"></i>
                                                                {{ solic.marcacao.nome_paciente }}
                                                            </div>
                                                            <div v-else-if="solic.apoiado">
                                                                <i class="fa-solid fa-house-signal fa-fw mr-2" aria-hidden="true"></i>
                                                                {{ solic.apoiado.search }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span class="badge badge-secondary">
                                                                {{ solic.items.length }}
                                                            </span>
                                                        </td>
                                                        <td>{{ solic.materiais }}</td>
                                                        <td width="1%">
                                                            <i class="fa fa-check text-success" aria-hidden="true" v-if="solic.atendido"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </template>

                            </div>

                            <div class="form-row">
                                <template v-if="item.fl_transfer">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            label="Local de Armazenagem de Origem"
                                            placeholder="De..."
                                            type="select"
                                            service="estoque_locals.index"
                                            optionsData="id_estoque_local"
                                            optionsMode="aql"
                                            :optionsParm="{ transf_origem: 1 }"
                                            optionsName="estoque_locals.index.origem.transf"
                                            required
                                            :validate="validate"
                                            :edicao="!lista_items.length"
                                            v-model="item.id_estoque_local" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            label="Local de Armazenagem de Destino"
                                            placeholder="Para..."
                                            type="select"
                                            service="estoque_locals.index"
                                            optionsData="id_estoque_local"
                                            optionsMode="aql"
                                            optionsName="estoque_locals.index.destino.transf"
                                            required
                                            :validate="validate"
                                            v-model="item.id_estoque_local_destino" />
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col col-12 col-md-3"> <!--  v-if="$store.state.unidade.unidade_operacaos.length > 1"> -->
                                        <az-input
                                            sizing="sm"
                                            label="Unidade"
                                            type="select"
                                            placeholder="Selecione..."
                                            :optionsList="$util.unidades_usuario(true)"
                                            optionsData="id_unidade_operacao"
                                            required
                                            :edicao="!item.fl_paciente || !item.id_marcacao"
                                            :validate="validate"
                                            v-model="item.centro_custo.id_unidade_operacao" />
                                    </div>
                                    <div class="col col-12 col-md-3"> 
                                        <az-input
                                            sizing="sm"
                                            label="Centro de Custo"
                                            type="select"
                                            placeholder="Selecione..."
                                            :optionsList="lista_centros"
                                            optionsData="id_centro_custo"
                                            required
                                            :edicao="item.centro_custo.id_unidade_operacao ? true : false"
                                            :validate="validate"
                                            v-model="item.id_centro_custo"
                                            @input="trocar_centro_custo" />
                                    </div>
                                    <div class="col col-12 col-md-3" v-if="info_local && !item.fl_solic_compra"> 
                                        <az-input
                                            :edicao="item.centro_custo.id_unidade_operacao ? true : false"
                                            required
                                            :validate="validate"
                                            sizing="sm"
                                            v-if="item.id_centro_custo"
                                            type="select"
                                            label="Local"
                                            placeholder="Selecione..."
                                            optionsMode="aql"
                                            :optionsParm="{ id_centro_custo: item.id_centro_custo }"
                                            :optionsName="'locais_por_centro.' + item.id_centro_custo"
                                            optionsDisplay="st_local"
                                            optionsData="id_local"
                                            service="locals.index"
                                            v-model="item.id_local" />
                                        
                                        <az-input
                                            v-else-if="1 == 0"
                                            sizing="sm"
                                            :edicao="false"
                                            label="Local"
                                            v-model="item.id_local" />
                                    </div>
                                    <div class="col col-12" :class="( info_local && !item.fl_solic_compra ) ? 'col-md-3' : 'col-md-6'">
                                        <az-input
                                            sizing="sm"
                                            label="Local de Armazenagem"
                                            placeholder="Selecione..."
                                            type="select"
                                            service="estoque_locals.index"
                                            optionsData="id_estoque_local"
                                            optionsMode="aql"
                                            :optionsFilter="filtro_local(item)"
                                            :optionsParm="{ solic_estoque: 1 }"
                                            optionsName="estoque_locals.index.solic_estoque"
                                            required
                                            :validate="validate"
                                            :edicao="!realizar_movimentacao_info || !lista_items.length"
                                            v-model="item.id_estoque_local" />
                                    </div>
                                </template>
                            </div>

                            <div class="form-row mt-3" v-if="!item.fl_transfer && !item.fl_solic_compra && centro_custo_selecionado && centro_custo_selecionado.fl_mov_apoiado">
                                <template v-if="!item.id_estoque_solicitacao">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            placeholder="Apoiado..."
                                            icon="fa-solid fa-house-signal fa-fw"
                                            sizing="sm"
                                            type="autocomplete"
                                            service="apoiados.index"
                                            optionsMode="aql"
                                            optionsName="apoiados.index"
                                            optionsData2="id_apoiado" 
                                            required
                                            :validate="validate"
                                            v-model="item.apoiado" />
                                    </div>

                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            placeholder="Origem..."
                                            icon="fa-solid fa-location-dot fa-fw"
                                            sizing="sm"
                                            type="autocomplete"
                                            service="apoiado_origens.index"
                                            optionsMode="aql"
                                            optionsName="apoiados.index"
                                            :optionsParm="{ id_apoiado: item.apoiado ? item.apoiado.id_apoiado : -1 }"
                                            required
                                            :validate="validate"
                                            v-if="( item.apoiado && item.apoiado.origens_count > 0 ) ? true : false"
                                            v-model="item.apoiado_origem" />
                                    </div>
                                </template>
                                <template v-else-if="item.apoiado">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            icon="fa-solid fa-house-signal fa-fw"
                                            sizing="sm"
                                            type="label"
                                            :label="item.apoiado.search" />
                                    </div>

                                    <div class="col col-12 col-md-6" v-if="item.apoiado_origem">
                                        <az-input
                                            icon="fa-solid fa-location-dot fa-fw"
                                            sizing="sm"
                                            type="label"
                                            :label="item.apoiado_origem.search" />
                                    </div>
                                </template>
                            </div>

                            <div class="form-row mt-3" v-else>
                                <div class="col col-12 col-md-3" v-if="!item.fl_transfer && !item.fl_solic_compra">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Para Paciente"
                                        :edicao="!item.id_estoque_solicitacao && !item.id_receita"
                                        v-model="item.fl_paciente"
                                        @click="item.id_marcacao = ''" />
                                </div>
                                <div class="col col-12" :class="( item.fl_transfer || item.fl_solic_compra ) ? '' : 'col-md-9'">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Observação..."
                                        v-model="item.st_observacao">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item && !item.fl_estorno">
                                                <button type="button" class="btn btn-outline-secondary" @click.prevent="com_componente = !com_componente" title="Lançamento com componentes">
                                                    <i class="fa-solid fa-link-simple-slash fa-fw" v-if="!com_componente"></i>
                                                    <i class="fa-solid fa-link-simple fa-fw" v-else></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <!-- Seleção do Paciente -->
                            <template v-if="item.fl_paciente && !item.id_estoque_solicitacao && !item.marcacao">
                                <selecao-marcacao 
                                    sizing="sm"
                                    ref="selmarc"
                                    :unidade="item.centro_custo ? item.centro_custo.id_unidade_operacao : null"
                                    :edicao="lista_items && !lista_items.length"
                                    :devolucao="item.fl_estorno"
                                    :validate="validate"
                                    v-model="item.id_marcacao"
                                    @input="obter_procs()" />

                                <div v-if="item.id_marcacao && item.procs && item.procs.length > 1">
                                    <div class="form-row">
                                        <div class="col col-12 offset-md-3 col-md-9">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecione o Procedimento..." 
                                                :optionsList="item.procs"
                                                optionsDisplay="search"
                                                optionsData="id_atendimento_procedimento"
                                                required
                                                :validate="validate"
                                                v-model="item.id_atendimento_procedimento" />

                                            <pre v-if="false">{{ item.procs }}</pre>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert alert-info px-2 py-1 d-flex justify-content-between" v-if="item.marcacao_sel && item.marcacao_sel.internacao">
                                    <div>
                                        <i class="fa-solid fa-bed mr-2"></i>
                                        #{{ item.marcacao_sel.internacao.id_internacao }}
                                        <span v-if="item.marcacao_sel.internacao.dt_alta"> | Alta: {{ $util.getFormatDate(item.marcacao_sel.internacao.dt_alta) }}</span>
                                        <span v-else-if="item.marcacao_sel.internacao.dt_prev_alta"> | <strong>Previsão de Alta: {{ $util.getFormatDate(item.marcacao_sel.internacao.dt_prev_alta) }}</strong></span>
                                    </div>
                                    <div>
                                        <span v-if="item.marcacao_sel.internacao.local">
                                            {{ item.marcacao_sel.internacao.local.search }}
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <!-- && item.id_estoque_solicitacao -->
                            <template v-else-if="item.fl_paciente && item.id_marcacao && item.marcacao">
                                <div class="form-row">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="date"
                                            label="Data do Atendimento"
                                            :edicao="false"
                                            v-model="item.marcacao.dt_inicio">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" v-if="item.marcacao.id_atendimento" title="Atendimento">
                                                        #{{ item.marcacao.id_atendimento }}
                                                    </span>
                                                    <span class="input-group-text" v-else title="Marcação">
                                                        M{{ item.id_marcacao }}
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-12 col-md-9">
                                        <az-input
                                            sizing="sm"
                                            label="Paciente"
                                            :edicao="false"
                                            v-model="item.marcacao.nome_paciente">
                                            <template v-if="!lista_items.length" v-slot:buttonposb>
                                                <div class="input-group-append" v-if="!item.fl_estorno">
                                                    <button type="button" class="btn btn-outline-primary" :disabled="$store.state.loading" @click="buscar_consumos()" title="Buscar itens lançados no atendimento.">
                                                        <i class="fa-solid fa-magnifying-glass-plus"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <div v-if="item.id_marcacao && item.procs && item.procs.length > 1">
                                    <div class="form-row">
                                        <div class="col col-12 offset-md-3 col-md-9">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecione o Procedimento..." 
                                                :optionsList="item.procs"
                                                optionsDisplay="search"
                                                optionsData="id_atendimento_procedimento"
                                                required
                                                :validate="validate"
                                                v-model="item.id_atendimento_procedimento" />

                                            <pre v-if="false">{{ item.procs }}</pre>
                                        </div>
                                    </div>
                                </div>

                                <div class="alert alert-info px-2 py-1 d-flex justify-content-between" v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.internacao">
                                    <div>
                                        <i class="fa-solid fa-bed mr-2"></i>
                                        #{{ item.marcacao.atendimento.internacao.id_internacao }}
                                        <span v-if="item.marcacao.atendimento.internacao.dt_alta"> | Alta: {{ $util.getFormatDate(item.marcacao.atendimento.internacao.dt_alta) }}</span>
                                        <span v-else-if="item.marcacao.atendimento.internacao.dt_prev_alta"> | <strong>Previsão de Alta: {{ $util.getFormatDate(item.marcacao.atendimento.internacao.dt_prev_alta) }}</strong></span>
                                    </div>
                                    <div>
                                        <span v-if="item.marcacao.atendimento.internacao.local">
                                            {{ item.marcacao.atendimento.internacao.local.search }}
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <template v-if="!item.id_estoque_solicitacao && !item.id_receita && retroativo && na_baixa && realizar_movimentacao">
                                <div class="form-row mt-3">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            label="Retroativo"
                                            v-model="item.retroativo" />
                                    </div>
                                    <div class="col col-12 col-md-3" v-if="item.retroativo">
                                        <az-input
                                            sizing="sm"
                                            type="datetime-local"
                                            icon="fa fa-calendar fa-fw"
                                            required
                                            :validate="validate"
                                            v-model="item.dt_retroativo" />
                                    </div>
                                </div>
                            </template>

                            <!-- ITENS DA SOLICITACAO -->
                            <az-sub-title class="mt-3" title="Itens" />

                            <div v-if="lista_horarios && lista_horarios.length" class="mb-1">
                                <i class="fa-solid fa-clock mr-2"></i>
                                <a href="#" @click.prevent="item.hr_aplic = ( item.hr_aplic == horario ? '' : horario )" v-for="(horario, ihx) in lista_horarios" :key="ihx">
                                    <span class="badge mr-1" :class="item.hr_aplic == horario ? 'badge-primary' : 'badge-secondary'">
                                        {{ horario.slice(-5) }}
                                    </span>
                                </a>

                                <a href="#" @click.prevent="gerar_aplics()" class="ml-3" v-if="atend_por_hr_aplic && item.dt_aplic && !item.hr_aplic" title="Gerar solicitação por horário aprazado.">
                                    <i class="fa-solid fa-alarm-plus"></i>
                                </a>

                                <a href="#" @click.prevent="gerar_aplics(true)" class="ml-3" v-if="atend_por_hr_aplic && item.dt_aplic && !item.hr_aplic" title="Gerar solicitação única para todos os horários aprazados.">
                                    <i class="fa-solid fa-calendar-day"></i>
                                </a>

                                
                            </div>

                            <div v-else-if="item && item.dt_aplic && item.id_estoque_solicitacao" class="small mb-1">
                                {{ $util.getFormatDate(item.dt_aplic) }} <span class="ml-2" v-if="item.hr_aplic"><i class="fa-solid fa-clock ml-2 mr-1"></i>{{ item.hr_aplic }}</span>
                            </div>

                            <div v-for="(material, imx) in lista_items" :key="imx">
                                <div class="form-row" :key="imx">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            :class="( material.id_estoque_item_kit && material.dt_aplic ) ? 'ml-3' : ''"
                                            sizing="sm"
                                            :edicao="false"
                                            v-model="material.item.search">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon1" @click="material.fl_ativo = false">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2" v-if="material.item.mav" title="MAV: Medicamento de Alta Vigilância">
                                                        <strong class="text-danger">MAV</strong>
                                                    </span>

                                                    <span class="input-group-text" v-if="material.fl_block_cobranca" title="Sem cobrança para esse item.">
                                                        <i class="fa-brands fa-creative-commons-nc"></i>    
                                                    </span>
                                                    
                                                    <span class="input-group-text" id="basic-addon2">#{{ material.item.id_estoque_item }}</span>

                                                    <button class="btn btn-outline-secondary btn-sm" type="button" id="button-addon2" v-if="material.item.show_comp === true || material.item.show_comp === false" @click="material.item.show_comp = !material.item.show_comp">
                                                        <i class="fa-solid fa-box-open fa-fw" v-if="material.item.show_comp"></i>
                                                        <i class="fa-solid fa-box fa-fw" v-else></i>
                                                    </button>

                                                    <button class="btn btn-outline-secondary btn-sm" type="button" id="button-addon2" v-if="material.item.fl_controla_lote && !material.lote && !( material && material.lotes && material.lotes.length )" title="Identificar Lote" @click="buscar_lotes(material)">
                                                        <i class="fa-solid fa-l"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                        <div class="mb-2" v-if="material.lote">
                                            <small class="text-muted ml-3">
                                                Lote: {{ material.lote.st_lote }} / Validade: {{ $util.getFormatDate(material.lote.dt_validade) }}
                                            </small>
                                        </div>
                                        <div v-else-if="material.item.fl_controla_lote && ( ( ( na_baixa || pode_baixar_direto ) && realizar_movimentacao ) || ( material && material.lotes && material.lotes.length ) )">
                                            <ul class="list-group mb-2" v-if="material && material.lotes && material.lotes.length">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(item_lote, ilx) in material.lotes" :key="ilx">
                                                    <div>
                                                        <a href="#" @click.prevent="selecionar_lote_lista(material, item_lote)">{{ item_lote.search }}</a>

                                                        <span v-if="item_lote.fl_consig" class="small text-muted ml-2">
                                                            <span class="mr-2">
                                                                (Consig) 
                                                            </span>
                                                            <span v-if="item_lote.fornecedor">
                                                                {{ item_lote.fornecedor.search }}
                                                            </span>
                                                            <span v-else-if="item_lote.id_fornecedor">
                                                                Fornecedor: #{{ item_lote.id_fornecedor }}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <template v-if="item_lote.saldo">
                                                            <span class="mr-2">{{ item_lote.saldo.qtd }}</span>
                                                            <i class="fas fa-boxes mr-5"></i>
                                                        </template>
                                                        
                                                        <span class="mr-2">{{ $util.getFormatDate(item_lote.dt_validade) }}</span>
                                                        <i class="fas fa-hourglass-end"></i>
                                                    </div>
                                                </li>
                                            </ul>

                                            <template v-else>
                                                <button type="button" class="btn btn-outline-secondary btn-sm ml-3 mb-2" @click="buscar_lotes(material)">
                                                    <i class="fa fa-search fa-fw mr-2" aria-hidden="true" v-if="material.item.lote && !material.item.lote.loading"></i>
                                                    <div class="spinner-border spinner-border-sm mr-2" role="status" v-else-if="material.item.lote && material.item.lote.loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                    Buscar Lotes...
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="number"
                                            required 
                                            :validate="validate"
                                            :min="0"
                                            :max="99999999"
                                            v-model="material.in_quantidade">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text small" id="basic-addon2">
                                                        {{ material.item.st_unidade_estoque }}    
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Observação..."
                                            v-model="material.st_observacao">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend" v-if="material.dt_aplic">
                                                    <span class="input-group-text small">
                                                        <template v-if="material.dt_aplic.length >= 16">
                                                            {{ material.dt_aplic.slice(8,10) }}
                                                        </template>
                                                        {{ material.dt_aplic.slice(-5) }}
                                                    </span>
                                                </div>
                                            </template>
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="material.saldo">
                                                    <span class="input-group-text small" id="basic-addon2" title="Saldo">
                                                        <div class="spinner-grow spinner-grow-sm" role="status" v-if="material.saldo.loading">
                                                        <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <template v-else>
                                                            S: {{ material.saldo.qtd }} 
                                                            <span class="ml-1" v-if="material.reservado > 0">
                                                                / R: {{ material.reservado }}
                                                            </span>

                                                            <i class="fa fa-exclamation-triangle text-danger ml-2" v-if="( material.saldo && !material.saldo.loading && material.saldo.qtd === 0 )" aria-hidden="true" title="Saldo Indisponível."></i>
                                                            <i class="fa fa-exclamation-triangle text-warning ml-2" v-else-if="( material.saldo && !material.saldo.loading && material.saldo.qtd < material.in_quantidade )" aria-hidden="true" title="Saldo Insuficiente."></i>
                                                            <i class="fa fa-exclamation-triangle text-info ml-2" v-else-if="( material.saldo && !material.saldo.loading && material.saldo.qtd < material.in_quantidade + material.reservado )" aria-hidden="true" title="Saldo com reservas insuficiente."></i>
                                                        </template>
                                                    </span>

                                                    <span class="input-group-text small" id="basic-addon2" title="Valor" v-if="ver_valores">
                                                        R$ 
                                                        <span class="ml-1" v-if="material.ultima_entrada && material.ultima_entrada.dc_valor" :title="'Última entrada #' + material.ultima_entrada.id_estoque_movimentacao">{{ $util.formatMoeda(material.ultima_entrada.dc_valor * material.in_quantidade) }}</span>
                                                        <span class="ml-1" v-else-if="material.saldo && material.saldo.pm">{{ $util.formatMoeda(material.saldo.pm * material.in_quantidade) }}</span>
                                                        <span class="ml-1" v-else>?</span>
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                

                                <div :key="'C' + imx" v-if="material.item && material.item.composicao && material.item.show_comp">
                                    <composicao-item-lista :mov="material.item.composicao" />
                                </div>
                            </div>

                            <selecao-material 
                                ref="selecmat" 
                                :consumo_paciente="item.fl_paciente ? true : false"
                                @selecionado="incluir_item" 
                                :id_estoque_local="item.id_estoque_local" 
                                :infoqt="true" 
                                :blocklote="!realizar_movimentacao_info" 
                                :kits="true" />

                            <div class="alert alert-secondary mt-3" v-if="ver_valores && valor_total > 0">
                                Valor Total: {{ $util.formatMoeda(valor_total) }}
                            </div>

                            <div class="mt-3" v-if="item && item.id_receita && receita && receita.flat_items && receita.flat_items.length">
                                <a href="#" @click.prevent="detalhe_prescr = !detalhe_prescr" class="card-link">
                                    <i class="fa fa-plus-square-o" aria-hidden="true" v-if="!detalhe_prescr"></i>
                                    <i class="fa fa-minus-square-o" aria-hidden="true" v-else></i>
                                    Detalhes Prescrição
                                </a>

                                <presc-suprimentos :receita="receita" v-if="detalhe_prescr" :data_aplic="item.dt_aplic" />
                            </div>

                            <br><br><br><br><br><br><br><br><br><br><br><br>

                        </template>                        
                    </div>
                    <div class="modal-footer d-flex justify-content-between flex-column flex-md-row">
                        <div class="d-flex">
                            <az-input
                                type="checkbox-group"
                                label="Imprimir" 
                                v-model="impresso_solicitacao" />

                            <az-input
                                class="ml-2"
                                type="checkbox-group"
                                label="Realizar Movimentação" 
                                v-model="realizar_movimentacao" 
                                v-if="( na_baixa || pode_baixar_direto ) && !( item && item.fl_solic_compra )" />

                            <az-input
                                class="ml-2"
                                type="checkbox-group"
                                label="Já Recebido" 
                                v-model="ja_recebido" 
                                v-if="item && na_baixa && realizar_movimentacao && !item.fl_estorno && !item.fl_transfer" />
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary" @click="nova()" v-if="item && item.id_estoque_solicitacao">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-secondary mx-1" data-dismiss="modal">Fechar</button>
                            <az-submit @click="salvar_solicitacao()" :disabled="reloading || ( item && item.block )">{{ item && item.id_estoque_solicitacao ? 'Atualizar' : 'Incluir' }}</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import SelecaoMarcacao from './SelecaoMarcacao.vue';
import PrescSuprimentos from '../../shared/PrescSuprimentos.vue';
import ComposicaoItemLista from './ComposicaoItemLista.vue';

export default {
    data() { 
        return { 
            dados: null, 
            validate: false, 
            item: null, 
            novoItem: "", 
            historico: [],
            realizar_movimentacao: true, 
            reloading: false, 
            impresso_solicitacao: false, 
            callback_pos_save: null, 
            ja_recebido: false, 
            retroativo: false, 
            receita: null, 
            detalhe_prescr: false, 
            modal_name: "estoqueSolicitacaoModal", 
            lista_estoque_local: null,
            ver_valores: false, 
            info_local: false, 
            trocando_centro_custo: false,
            sempre_ver_saldos: false, 
            com_componente: true, 
            atend_por_hr_aplic: false, 
            lista_inclusao: [], 
            callback_conclusao: null 
        };
    },

    components: { 
        AzInput, 
        AzSubmit, 
        AzSubTitle, 
        SelecaoMaterial, 
        SelecaoMarcacao, 
        PrescSuprimentos, 
        ComposicaoItemLista, 
    },

    computed: { 
        lista_horarios: function () { 
            if ( !this.item || !this.item.dt_aplic || !this.item.items ) { 
                return [];
            }

            return _.uniq(
                    this.item.items.filter(item => !item.dt_aplic)
                        .flatMap(item => { 
                            let base = ""; 
                            let dt_aplic = this.item.dt_aplic; 

                            // console.log('horarios', item.item.search, item.horarios);

                            return item.horarios 
                                ? item.horarios.map(hor => { 
                                    if ( hor && hor.horario && hor.horario.length > 10 ) { 
                                        return hor.horario;
                                    }

                                    if ( !base ) { 
                                        base = hor.horario;
                                    } else if ( hor.horario < base ) { 
                                        base = hor.horario;
                                        dt_aplic = moment(dt_aplic, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');
                                    }
                                    
                                    return dt_aplic + ' ' + hor.horario;
                                }) 
                                : []  
                        })
                ).sort();
        },

        centro_custo_selecionado: function () { 
            if ( !this.item || !this.item.id_centro_custo )
                return null;

            let unidade = this.$util.unidade_operacao(this.item.centro_custo.id_unidade_operacao);

            if ( unidade ) { 
                return unidade.centro_custos.find(cc => cc.id_centro_custo == this.item.id_centro_custo);
            }

            return null;
        },

        realizar_movimentacao_info: function () { 
            return ( ( this.na_baixa || this.pode_baixar_direto ) && this.realizar_movimentacao ) ? true : false;
        },

        lista_centros: function () { 
            if ( !this.item || !this.item.centro_custo || !this.item.centro_custo.id_unidade_operacao ) 
                return [];

            return this.$util.centros_usuario(this.item.centro_custo.id_unidade_operacao, !this.na_baixa);
        },
        
        lista_items: function () { 
            if ( !this.item )
                return [];

            return this.item.items.filter(item => item.fl_ativo)
                .filter(item => !this.item.hr_aplic 
                    || !item.horarios
                    || item.horarios.find(hor => hor.horario == this.item.hr_aplic.slice(-5))
                );
        },

        na_baixa: function () { 
            return this.$route.path == '/suprimentos/atendimento';
        },

        pode_baixar_direto: function () { 
            if ( !this.lista_estoque_local || !this.item ) { 
                return false;
            }

            return _.get(this.lista_estoque_local, this.item.id_estoque_local + '.fl_baixa_solic') ? true : false;
        },

        valor_total: function () { 
            if ( !this.ver_valores ) 
                return;

            return this.lista_items.reduce((total, carry) => { 
                if ( carry.ultima_entrada ) { 
                    return total + ( parseFloat(carry.ultima_entrada ? carry.ultima_entrada.dc_valor : 0) * parseFloat(carry.in_quantidade) );    
                }
                return total + ( parseFloat(carry.saldo ? carry.saldo.pm : 0) * parseFloat(carry.in_quantidade) );
            }, 0);
        }
    },

    methods: { 
        get_items (hr_aplic) { 
            if ( !this.item )
                return [];

            return _.cloneDeep(
                this.item.items.filter(item => item.fl_ativo && !item.id_estoque_solicitacao_item)
                    .filter(item => !item.horarios
                        || item.horarios.find(hor => hor.horario == hr_aplic)
                    )
            );
        },

        gerar_aplics (consolidado = false) { 
            let nova_lista = []; 

            this.lista_horarios.forEach(horario => { 
                let items_horario = this.get_items(horario.slice(-5)).map(item => { 
                    item.dt_aplic = horario; 
                    return item; 
                });

                if (consolidado) {
                    items_horario.forEach(item => { 
                        let busca = nova_lista.find(i => i.fl_ativo 
                            && i.item.id_estoque_item == item.item.id_estoque_item
                            && ( !_.get(item, 'lote.st_lote') || _.get(i, 'lote.st_lote') == _.get(item, 'lote.st_lote') ) 
                        );

                        if ( busca ) { 
                            busca.in_quantidade = parseInt(busca.in_quantidade) + parseInt( item.in_quantidade ? item.in_quantidade : 1 );
                        } else { 
                            nova_lista.push(item);
                        }
                    });
                } else { 
                    nova_lista = nova_lista.concat(items_horario);
                }
            });

            this.item.items = nova_lista; 
        },

        trocar_centro_custo () { 
            console.log('trocando...');

            if ( this.item && this.item.id_centro_custo ) { 
                this.com_componente = ( this.$util.getCookie('sol-no-comp-' + this.item.id_centro_custo) != 'N' ) ? true : false;
            }

            this.trocando_centro_custo = true; 

            this.$nextTick(() => { 
                this.trocando_centro_custo = false; 
            });
        },

        buscar_consumos () { 
            this.$util.load(this, { 
                service: 'estoque',
                func: 'obter_itens_consumidos',
                parms: { 
                    id_marcacao: this.item.marcacao.id_marcacao, 
                    id_atendimento_procedimento: this.item.id_atendimento_procedimento,
                },
                loadTo: res => { 
                    if ( res.lista && res.lista.length ) { 
                        res.lista.forEach(item => { 
                            this.incluir_item(
                                { 
                                    ...item.item, 
                                    fl_block_cobranca: true, 
                                    quantidade: item.qtde, 
                                }
                            );
                        });
                    } else { 
                        this.$toast.add({
                            severity: "warn",
                            summary: "Atenção",
                            detail: "Nenhum item identificado para lançamento.",
                            life: 3000
                        });
                    }
                }
            });
        },

        selecionar_lote_lista (material, item_lote) { 
            material.lote = _.cloneDeep(item_lote);
        },

        buscar_lotes(item) { 
            if ( item && item.item && !item.item.lote ) { 
                item.item.lote = { 
                    numero: "", 
                    validade: "", 
                    item: "", 
                    loading: "", 
                };

                this.$forceUpdate();
            }

            if ( !item || !item.item || !item.item.lote )
                return;

            item.item.lote.loading = true;

            this.$util.loadItem(this, { 
                service: "estoque_lotes",
                func: 'index',
                parms: { 
                    id_estoque_item: item.item.id_estoque_item, 
                    id_estoque_local: this.item.id_estoque_local,
                    saldos: true, 
                    id_marcacao: ( ( this.item.id_marcacao && this.item.fl_estorno ) ? this.item.id_marcacao : null ), 
                }
            })
            .then(res => { 
                console.log(res);

                item.lotes = _.orderBy(
                    res.filter(item => this.item.fl_estorno || ( item.saldo && item.saldo.qtd > 0 ) ),
                    'dt_validade'
                );

                this.$forceUpdate();
            })
            .finally(() => { 
                item.item.lote.loading = false;
            });
        },

        obter_procs () { 
            this.item.id_atendimento_procedimento = "";
            this.item.procs = this.$refs.selmarc.get_procs();

            if ( this.item.procs && this.item.procs.length > 1 ) { 
                // 
            } else { 
                let marcacao = this.$refs.selmarc.get_marcacao();

                this.item.marcacao_sel = marcacao; 

                if ( marcacao && marcacao.id_centro_custo ) { 
                    this.item.id_centro_custo = marcacao.id_centro_custo;
                }
            }
        },

        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        copiar (solic) { 
            this.impresso_solicitacao = ( this.$util.getCookie('solic-impresso') == 'S' );
            
            this.validate = false;

            let nova = _.cloneDeep(solic);
            nova.id_estoque_solicitacao = null;
            nova.dt_solicitacao = "";

            nova.items.forEach(item => { 
                item.id_estoque_solicitacao = null;
                item.id_estoque_solicitacao_item = null;
                item.fl_pendente = true;
                item.qtde_baixa = null;
            });

            this.item = nova;

            $('#solic_anteriores').collapse('hide');
        },

        filtro_local(item) { 
            if ( this.$store.state.unidade.sol_unid_dif ) {
                return {};
            }

            return { 
                id_unidade_operacao: ( item.centro_custo && item.centro_custo.id_unidade_operacao ) 
                    ? item.centro_custo.id_unidade_operacao 
                    : -1 
            };
        },

        incluir_item(novo = null, callback = null) { 
            if ( !novo ) { 
                if ( this.lista_inclusao && this.lista_inclusao.length ) { 
                    novo = this.lista_inclusao.shift();
                    console.log('Inclusão de:', novo.item ? novo.item.search : novo.id_estoque_item, 'F:' + this.lista_inclusao.length, _.cloneDeep(this.lista_inclusao)); 
                } else { 
                    console.log('Terminou Inclusão!');
                    if ( this.callback_conclusao ) { 
                        this.callback_conclusao(); 
                    }
                    return;
                }
            }

            let busca = this.item.items.find(item => item.fl_ativo 
                && item.item.id_estoque_item == novo.id_estoque_item
                && ( !_.get(novo, 'lote.item') || _.get(item, 'lote.st_lote') == _.get(novo, 'lote.item.st_lote') ) 
                && !item.st_observacao
                && !item.id_receita_medicamento
            );

            if ( busca ) { 
                busca.in_quantidade = parseInt(busca.in_quantidade) + parseInt( novo.quantidade ? novo.quantidade : 1 );
                this.incluir_item(); 
                return; 
            }

            console.log('novo', novo);

            let novoitem = { 
                id_estoque_solicitacao: this.item.id_estoque_solicitacao, 
                id_estoque_item: null, 
                id_estoque_item_kit: novo.id_estoque_item_kit, 
                item: novo, 
                in_quantidade: novo.quantidade ? novo.quantidade : 1,
                id_receita_medicamento: novo.id_receita_medicamento ? novo.id_receita_medicamento : null,
                fl_pendente: true, 
                st_observacao: "", 
                fl_ativo: true, 
                mav: false, 
                fl_block_cobranca: novo.fl_block_cobranca ? novo.fl_block_cobranca : false,
                lote: _.get(novo, 'lote.item'), 
                horarios: _.get(novo, 'horarios'),
            };

            if ( !this.item.fl_estorno && ( this.na_baixa || this.ver_valores || this.sempre_ver_saldos ) ) { 
                novoitem.saldo = { 
                    loading: true,
                };
            }

            this.item.items.push(novoitem);

            if ( novoitem && novoitem.saldo ) {  

                console.log('Aqui... carregando saldo para', this.item.id_estoque_local, novo);

                this.$util.loadItem(this, { 
                    service: "estoque_items",
                    id: novo.id_estoque_item, 
                    parms: { 
                        saldos: true, 
                        id_estoque_local: this.item.id_estoque_local,
                        id_unidade_operacao: ( this.item && this.item.centro_custo && this.item.centro_custo.id_unidade_operacao ) ? this.item.centro_custo.id_unidade_operacao : null,
                        num_lote: _.get(novo, 'lote.item.st_lote'), 
                        reservas: true, 
                        componentes: true, 
                        mav: true, 
                        id_receita_medicamento: _.get(novo, 'id_receita_medicamento'),
                    }
                })
                .then(res => { 
                    if ( !res.saldo ) { 
                        novoitem.saldo = { 
                            qtd: 0, 
                        };
                        novoitem.reservado = 0;
                    } else { 
                        novoitem.saldo = res.saldo;
                        novoitem.reservado = res.reservado ? res.reservado : 0;
                    }

                    if ( res.ultima_entrada ) { 
                        novoitem.ultima_entrada = res.ultima_entrada;
                    }

                    if ( res.mav ) { 
                        novoitem.item.mav = res.mav;
                    }

                    if ( !this.item.fl_estorno ) { 

                        if ( this.com_componente && res.componentes && res.componentes.length ) { 
                            res.componentes.map(comp => { 
                                return { 
                                    ...comp.item, 
                                    quantidade: comp.in_quantidade * ( comp.in_para_cada ? Math.ceil ( novoitem.in_quantidade / ( comp.in_para_cada > 0 ? comp.in_para_cada : 1 ) ) : 1 ),
                                    horarios: novo.horarios,
                                    id_estoque_item_kit: novo.id_estoque_item,
                                    is_comp: true, 
                                }
                            })
                            .forEach(comp => { 
                                this.lista_inclusao.unshift(comp);
                                // this.incluir_item(comp);
                            });
                        }

                    }

                    if ( callback ) { 
                        callback(); 
                    }

                    this.incluir_item(); 
                    
                    this.$forceUpdate();
                });
                
            } else if ( !this.item.fl_estorno && novo.componentes_count ) { 

                console.log('Aqui2... carregando saldo para', novo);

                this.$util.loadItem(this, { 
                    service: "estoque_items",
                    id: novo.id_estoque_item, 
                    parms: { 
                        id_estoque_local: this.item.id_estoque_local,
                        id_unidade_operacao: ( this.item && this.item.centro_custo && this.item.centro_custo.id_unidade_operacao ) ? this.item.centro_custo.id_unidade_operacao : null,
                        componentes: novo.block_comp ? false : true,
                        id_receita_medicamento: _.get(novo, 'id_receita_medicamento'),
                    }
                })
                .then(res => {
                    if ( this.com_componente && res.componentes && res.componentes.length ) { 
                        res.componentes.map(comp => { 
                            return { 
                                ...comp.item, 
                                quantidade: comp.in_quantidade * ( comp.in_para_cada ? Math.ceil ( novoitem.in_quantidade / ( comp.in_para_cada > 0 ? comp.in_para_cada : 1 ) ) : 1 ),
                                horarios: novo.horarios,
                                id_estoque_item_kit: novo.id_estoque_item,
                                is_comp: true, 
                            }
                        })
                        .forEach(comp => { 
                            this.lista_inclusao.unshift(comp);
                            // this.incluir_item(comp);
                        });
                    }

                    this.incluir_item(); 
                });

            } else { 

                this.incluir_item(); 

            }

            /*
            this.$nextTick(() => { 
                this.novoItem = "";
            });
            */
        },

        editar(solic) { 
            this.impresso_solicitacao = ( this.$util.getCookie('solic-impresso') == 'S' );
            
            this.validate = false;
            this.item = solic;
            this.receita = null;

            $('#solic_anteriores').collapse('hide');
        },

        nova(tipo = "S", parms = null) { 
            this.impresso_solicitacao = ( this.$util.getCookie('solic-impresso') == 'S' );
            this.receita = null;

            let id_unidade_operacao = ""; 
            let id_centro_custo = "";

            let lista = this.$store.state.options['estoque_locals.index'];

            if ( !lista ) { 
                setTimeout(() => { 
                    lista = this.$store.state.options['estoque_locals.index.solic_estoque']
                        ? this.$store.state.options['estoque_locals.index.solic_estoque']
                        : this.$store.state.options['estoque_locals.index'];

                    this.lista_estoque_local = _.mapKeys(lista, 'id_estoque_local');

                    if ( lista ) { 
                        let teste = lista.find(item => item.id_estoque_local == this.$util.getCookie('estoque-armazem'));

                        if ( teste ) { 
                            if ( this.item && this.item.centro_custo ) { 
                                this.item.centro_custo.id_unidade_operacao = teste.id_unidade_operacao;
                            }
                        }
                    }
                }, 1000);
            } else { 
                this.lista_estoque_local = _.mapKeys(lista, 'id_estoque_local');
            }

            if ( this.$util.getCookie('estoque-armazem') ) { 
                let lista = this.$store.state.options['estoque_locals.index'];

                if ( lista ) { 
                    let teste = lista.find(item => item.id_estoque_local == this.$util.getCookie('estoque-armazem'));

                    if ( teste ) { 
                        id_unidade_operacao = teste.id_unidade_operacao;

                        if ( parms && !parms.id_estoque_local ) { 
                            parms.id_estoque_local = teste.id_estoque_local;
                        }
                    } else if ( lista.length == 1 ) { 
                        id_unidade_operacao = lista[0].id_unidade_operacao;

                        if ( parms && !parms.id_estoque_local ) { 
                            parms.id_estoque_local = lista[0].id_estoque_local;
                        }
                    }
                }
            }

            if ( !this.id_unidade_operacao && this.$util.unidades_usuario().length == 1 ) { 

                id_unidade_operacao = this.$util.unidades_usuario()[0].id_unidade_operacao;

            } else if ( !this.id_unidade_operacao && this.$store.state.unidade.unidade_operacaos.length == 1 ) { 

                id_unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;

                if ( this.$store.state.unidade.unidade_operacaos[0].centro_custos.length == 1 ) { 
                    id_centro_custo = this.$store.state.unidade.unidade_operacaos[0].centro_custos[0].id_centro_custo;
                }

            }

            if ( parms && parms.marcacao && parms.marcacao.id_unidade_operacao && parms.marcacao.id_unidade_operacao != id_unidade_operacao ) { 
                id_unidade_operacao = parms.marcacao.id_unidade_operacao;
                id_centro_custo = "";
            }

            this.validate = false;

            this.item = { 
                id_estoque_solicitacao: null, 
                centro_custo: { 
                    id_unidade_operacao: ( id_unidade_operacao ? id_unidade_operacao : _.get(parms, 'marcacao.id_unidade_operacao') ), 
                },
                id_centro_custo: ( ( parms && parms.id_centro_custo ) ? parms.id_centro_custo : id_centro_custo ), 
                id_estoque_local: ( parms && ( parms.id_estoque_local || parms.id_estoque_local_destino ) ) ? parms.id_estoque_local : this.$util.getCookie('estoque-armazem'), 
                id_estoque_local_destino: ( parms && parms.id_estoque_local_destino ) ? parms.id_estoque_local_destino : null,
                id_local: ( ( parms && parms.id_local ) ? parms.id_local : null ), 
                st_observacao: "", 
                fl_estorno: tipo == 'D' ? true : false, 
                fl_transfer: tipo == 'T' ? true : false, 
                fl_solic_compra: tipo == 'A' ? true : false, 
                fl_paciente: ( parms && parms.marcacao && parms.marcacao.id_marcacao ) ? true : false, 
                id_marcacao: ( parms && parms.marcacao ) ? parms.marcacao.id_marcacao : null,
                id_receita: ( parms && parms.id_receita ) ? parms.id_receita : null,
                marcacao: ( parms && parms.marcacao ) ? parms.marcacao : null, 
                items: [], 
                retroativo: false,
                dt_retroativo: null,
                procs: [],
                id_atendimento_procedimento: ( ( parms && parms.id_atendimento_procedimento ) ? parms.id_atendimento_procedimento : null ), 
                block: false, 
                dt_aplic: parms ? parms.data_aplic : null, 
                hr_aplic: "", 
            };

            if ( parms && parms.marcacao && parms.marcacao.procs ) { 
                this.item.procs = parms.marcacao.procs;
            } 

            //console.log('parms', this.item);
            //console.log('item', this.item);

            if ( parms && parms.id_receita && parms.items ) { 
                this.$util.loadItem(this, { 
                    service: 'estoque',
                    func: 'convert_items_receita',
                    parms: parms, 
                })
                .then(res => { 

                    if ( res ) { 

                        if ( res && res.lista && res.lista.length ) { 
                            this.lista_inclusao = res.lista.map(item => { 
                                return { 
                                    ...item.item, 
                                    id_estoque_item_kit: item.id_estoque_item_kit,
                                    quantidade: item.qtde, 
                                    id_receita_medicamento: item.id_receita_medicamento, 
                                    horarios: item.horarios,
                                }
                            });

                            this.callback_conclusao = () => { 
                                console.log('Inclusão de itens concluída!', res.receita);
                                this.$nextTick(() => { 
                                    console.log('Lista de horários', this.item.dt_valid_ini, this.lista_horarios);
                                    if ( res.receita && res.receita.dt_valid_ini && this.lista_horarios.length ) { 
                                        console.log('gerar-aplics-pre');
                                        this.gerar_aplics(); 
                                        this.callback_conclusao = null; 
                                        console.log('gerar-aplics-pos');
                                    }
                                });
                            }
                            
                            //this.incluir_item({ ...item.item, quantidade: item.qtde, id_receita_medicamento: item.id_receita_medicamento, horarios: item.horarios });

                            this.incluir_item(); 
                        }

                        this.receita = res.receita;

                    } else { 

                        if ( res === undefined ) { 
                            this.item.block = true;
                            this.$forceUpdate();

                            setTimeout(() => { 
                                $('.modal').modal('hide');
                            }, 1000);
                        }

                    }

                });

            } else if ( parms && parms.transf && parms.items ) {

                parms.items.forEach(item => { 
                    this.incluir_item({ ...item.item, quantidade: item.qtde, block_comp: true });
                });

            }

            if ( id_unidade_operacao && this.lista_centros.length == 1 ) { 
                this.item.id_centro_custo = this.lista_centros[0].id_centro_custo;
            }

            console.log('NOVA TERMINOU!'); 

            this.$nextTick(() => { 
                if ( this.lista_centros && this.lista_centros.lista_centros && this.lista_centros.lista_centros.length == 1 ) { 
                    this.item.id_centro_custo = this.lista_centros.lista_centros[0].id_centro_custo;
                } else  if ( this.lista_centros && this.lista_centros.length == 1 ) { 
                    this.item.id_centro_custo = this.lista_centros[0].id_centro_custo;
                }
            });
        },

        solicitar (tipo = 'S', parms = null, callback_pos_save = null) { 

            this.ver_valores = false;
            this.realizar_movimentacao = ( this.$route.path == '/suprimentos/atendimento' );

            this.callback_pos_save = callback_pos_save;
            this.receita = null;

            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.historico = null;

            this.nova(tipo, parms);

            this.$util.loadItem(this, { 
                service: 'estoque_solicitacoes',
                func: 'index',
                size: 5,
                with: [
                        'items.item',
                        'items.movimentacao',
                        'items.link', 
                        'local',
                        'destino', 
                        'centroCusto',
                        'marcacao.paciente', 
                        'marcacao.cadastro_temporario', 
                        'marcacao.procedimento.especialidade', 
                        'marcacao.atendimento_procedimentos.procedimento:id_procedimento,st_procedimento',
                        'marcacao.atendimento:id_atendimento,id_internacao', 
                        'marcacao.atendimento.internacao:id_internacao,dt_prev_alta,dt_alta,id_local,id_local_momento',
                        'marcacao.atendimento.internacao.local:id_local,st_local,st_sigla,id_centro_custo', 
                        'marcacao.atendimento.internacao.local.centroCusto:id_centro_custo,id_unidade_operacao,st_nome', 
                        'marcacao.atendimento.internacao.local.centroCusto.unidadeOperacao:id_unidade_operacao,st_nome,st_sigla',
                        'marcacao.atendimento.internacao.local_momento:id_local,st_local,st_sigla',
                        'apoiado', 
                        'apoiado_origem',
                    ],
                parms: { 
                    where: { 
                        id_usuario: this.$store.state.user.id_usuario, 
                    },
                    historico: true, 
                    tipo: tipo, 
                },
                configs: [
                    'estoq-mov-retroativo', 
                    'estoq-trasnf-view-valor', 
                    'estoq-solic-info-local',
                    'estoq-solic-ver-saldos', 
                    'estoque-solic-atender-por-horario',
                ],
            })
            .then(res => { 
                this.historico = res;

                if ( parms && parms.id_estoque_solicitacao && this.historico ) { 
                    let solic = this.historico.find(item => item.id_estoque_solicitacao == parms.id_estoque_solicitacao);

                    if ( solic ) { 
                        this.editar(solic);
                    }
                }

                this.retroativo = this.$store.state.contexto['estoq-mov-retroativo'] == 1;
                this.ver_valores = ( tipo == 'T' && this.$store.state.contexto['estoq-trasnf-view-valor'] == 1 );
                this.sempre_ver_saldos = this.$store.state.contexto['estoq-solic-ver-saldos'] == 1;
                this.info_local = this.$store.state.contexto['estoq-solic-info-local'] == 1;
                this.atend_por_hr_aplic = !!this.$store.state.contexto['estoque-solic-atender-por-horario'];
            })
            .catch(() => { 
                $('#' + this.modal_name).modal('hide');
                this.historico = null;
            });

            this.$nextTick(() => { 
                if ( this.$refs.selecmat ) { 
                    this.$refs.selecmat.reset();
                }
                
                $('#' + this.modal_name).modal('show');
            });

        },

        reload (id) { 

            this.$util.loadItem(this, { 
                service: 'estoque_solicitacoes',
                func: 'show',
                parms: { 
                    id: id 
                },
                with: [
                    'items.item',
                    'local',
                    'destino', 
                    'centroCusto',
                    'marcacao.paciente', 
                    'apoiado', 
                    'apoiado_origem',
                ],
            })
            .then(res => { 
                this.item = res;
            })
            .catch(() => { 
                $('#' + this.modal_name).modal('hide');
                this.historico = null;
            })
            .finally(() => { 
                this.reloading = false;
            });

        },


        salvar_solicitacao () { 

            //

            let teste_item = ( this.$refs.selecmat ? this.$refs.selecmat.item_selecionado() : '' ); 

            if ( teste_item ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Item '" + teste_item + "' selecionado, mas não adicionado.",
                    life: 5000
                });
                return;
            }

            //

            if ( this.item && this.item.items && !this.item.items.length ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Nenhum item adicionado na solicitação.",
                    life: 3000
                });
                return;
            }

            //

            this.$util.setCookie('solic-impresso', this.impresso_solicitacao ? 'S' : 'N');

            if ( this.item.id_centro_custo ) { 
                this.$util.setCookie('sol-no-comp-' + this.item.id_centro_custo, this.com_componente ? '' : 'N');
                console.log('cookie', 'sol-no-comp-' + this.item.id_centro_custo, this.$util.getCookie('sol-no-comp-' + this.item.id_centro_custo));
            }

            this.$util.atualizar (this, { 
                service: 'estoque',
                func: 'salvar_solicitacao',
                dados: { 
                    ...this.item,
                    realizar_movimentacao: this.realizar_movimentacao_info, 
                    ja_recebido: this.realizar_movimentacao_info && this.ja_recebido && !this.item.fl_estorno && !this.item.fl_transfer, 
                },
                modal: this.modal_name,
                toast: true, 
                msg: 'Solicitação Enviada!',
                callback: res => { 
                    this.$emit('refresh');

                    if ( res && res.id_estoque_solicitacao && this.impresso_solicitacao ) { 
                        this.imprimir_solicitacao(res);
                    }

                    if ( this.callback_pos_save ) { 
                        this.callback_pos_save(res);
                    }
                },
                error: err => { 
                    if ( !this.item.id_estoque_solicitacao && err.id_estoque_solicitacao ) { 
                        this.reloading = true;
                        this.reload (err.id_estoque_solicitacao);
                    }
                    console.log('Erro', err);
                }
            });
        },

        imprimir_solicitacao (solic) { 
            this.$util.print_preview('imprimir/solicitacao/' + solic.id_estoque_solicitacao, true);
        },
    },

    mounted() { 
        this.modal_name = "estoqueSolicitacaoModal" + this.uuidv4();
        this.realizar_movimentacao = ( this.$route.path == '/suprimentos/atendimento' );
    }

}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>